import styled from '@emotion/styled'
import DocumentLoader from './DocumentLoader'

const AddButton = ({
  text = '',
  onClick,
  height = '20px',
  disabled,
  loading,
  sx,
  font_size = '13.28px',
  title
}) => {
  return (
    <AddButtonContainer
      onClick={onClick}
      height={height}
      disabled={disabled || loading}
      loading={loading}
      sx={sx}
      font_size={font_size}
      title={title}
    >
      {text}
      {loading && (
        <DocumentLoader size={13} thickness={3} showText={false} mt={0} />
      )}
    </AddButtonContainer>
  )
}

const AddButtonContainer = styled.button`
  color: #666;
  background: ${({ theme }) => theme.colors.lightGray};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: 0.3s;
  height: ${({ height }) => height};
  border: none;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ font_size }) => font_size};
  gap: 5px;
  ${({ sx }) => sx}
  &:hover {
    background: ${({ disabled }) => (disabled ? '#ccc' : '#999')};
    color: ${({ theme, disabled }) => (disabled ? '#666' : theme.colors.white)};
  }
`

export default AddButton
